/**
 * GSAP staggered reveal for panels. Phase 1.
 *
 * Imported lazily so the GSAP runtime isn't pulled into the initial
 * bundle — `revealPanels()` is called once from Dashboard.onMount.
 *
 * Phase 0/1 fallback: pure CSS fade-in via the `data-reveal` attribute
 * so the dashboard still feels alive before GSAP loads.
 */
export async function revealPanels(root: HTMLElement) {
  const panels = root.querySelectorAll<HTMLElement>("[data-panel]");
  if (panels.length === 0) return;

  // CSS fallback fires immediately.
  for (const p of panels) p.dataset.reveal = "true";

  try {
    // Optional runtime dep — added in Phase 1. String is computed so
    // Rollup doesn't fail the build before it ships.
    const moduleId = "gs" + "ap";
    const mod = await import(/* @vite-ignore */ moduleId);
    const gsap = (mod as { gsap?: unknown }).gsap ?? mod;
    type GsapApi = {
      fromTo: (
        targets: unknown,
        from: Record<string, unknown>,
        to: Record<string, unknown>,
      ) => void;
    };
    (gsap as GsapApi).fromTo(
      panels,
      { y: 12, opacity: 0 },
      {
        y: 0,
        opacity: 1,
        duration: 0.55,
        ease: "power3.out",
        stagger: { each: 0.04, from: "start" },
      },
    );
  } catch {
    /* gsap not installed in Phase 0; CSS handles it */
  }
}
